import { Component, OnInit } from '@angular/core';
import { PatientPortalService } from 'src/app/core/services/patient-portal.service';
import { Protocol, ProtocolsResponse, ApiResponse } from 'src/app/core/models/patientportal';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-myprotocol',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './myprotocol.component.html',
  styleUrls: ['./myprotocol.component.scss']
})
export class MyprotocolComponent implements OnInit {

  protocols: Protocol[] = [];
  loading = false;
  errorMsg = '';

  query = {
    page: 1,
    limit: 10,
    status: ''
  };

  totalPages = 1;
  pages: number[] = [];

  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Paused', value: 'PAUSED' },
    { label: 'Completed', value: 'COMPLETED' }
  ];

  constructor(private service: PatientPortalService) { }

  ngOnInit(): void {
    this.fetchProtocols();
  }

  fetchProtocols() {
    this.loading = true;

    const params: any = {
      page: this.query.page,
      limit: this.query.limit
    };

    if (this.query.status) {
      params.status = this.query.status;
    }

    this.service.getProtocols(params).subscribe({
      next: (res: ApiResponse<ProtocolsResponse>) => {
        this.protocols = res.data.protocols || [];
        this.totalPages = res.data.pagination?.totalPages || 1;

        this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

        this.loading = false;
      },
      error: () => {
        this.errorMsg = 'Failed to load protocols';
        this.loading = false;
      }
    });
  }

  applyFilters() {
    this.query.page = 1;
    this.fetchProtocols();
  }

  goToPage(p: number) {
    if (p < 1 || p > this.totalPages) return;
    this.query.page = p;
    this.fetchProtocols();
  }

  trackById(i: number, item: Protocol) {
    return item._id;
  }

  // 🔥 EXTRA FEATURES

  getCount(status: string) {
    return this.protocols.filter(p => p.status === status).length;
  }

  getDueSoonCount() {
    const now = new Date();
    return this.protocols.filter(p => {
      const due = new Date(p.nextDueDate);
      const diff = (due.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
      return diff <= 7 && diff >= 0;
    }).length;
  }

  isDueSoon(date: string) {
    const now = new Date();
    const due = new Date(date);
    const diff = (due.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
    return diff <= 7 && diff >= 0;
  }

  getProgress(p: Protocol) {
    const start = new Date(p.startDate).getTime();
    const end = new Date(p.nextDueDate).getTime();
    const now = new Date().getTime();

    const total = end - start;
    const current = now - start;

    return Math.min(100, Math.max(0, (current / total) * 100));
  }
}